<template>
    <div>
        <div :width="1300">
            <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="列表">
                    <!-- 表格 -->
                    <vxe-table
                        ref="table"
                        size="mini"
                        resizable
                        auto-resize
                        row-id="id"
                        align="left"
                        header-align="center"
                        highlight-hover-row
                        highlight-current-row
                        show-overflow="tooltip"
                        :data="hisProData"
                        height="500"
                    >
                        <vxe-table-column field="act_name_" title="节点名称" width="100" align="center"> </vxe-table-column>
                        <vxe-table-column field="personnel_no" title="操作人编号" width="80" align="center"> </vxe-table-column>
                        <vxe-table-column field="personnel_name" title="操作人姓名" width="100" align="center"> </vxe-table-column>
                        <vxe-table-column field="czlx" title="操作类型" width="100" align="center">
                            <template v-slot="{ row }">
                                <span :style="{ color: row.czlx === '正在审批' ? '#11ef11' : '#606266' }"> {{ row.czlx }} </span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="message_" title="操作说明"> </vxe-table-column>
                        <vxe-table-column field="start_time_" title="生成时间" width="150">
                            <template v-slot="{ row }">
                                <span> {{ $FG_util.timestampToTime(row.start_time_) }} </span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="end_time_" title="操作时间" width="150">
                            <template v-slot="{ row }">
                                <span> {{ $FG_util.timestampToTime(row.end_time_) }} </span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="org_no" title="组织编号" width="80" align="center"> </vxe-table-column>
                        <vxe-table-column field="org_name" title="组织姓名" width="120" align="center"> </vxe-table-column>
                    </vxe-table>
                </a-tab-pane>
                <a-tab-pane key="2" tab="流程图" force-render>
                    <div class="containers">
                        <div class="canvas" ref="canvas"></div>
                    </div>
                </a-tab-pane>
                <a-tab-pane key="3" tab="操作日志">
                    <!-- 表格 -->
                    <vxe-table
                        ref="table"
                        size="mini"
                        resizable
                        auto-resize
                        row-id="id"
                        align="left"
                        header-align="center"
                        highlight-hover-row
                        highlight-current-row
                        show-overflow="tooltip"
                        :data="tableData"
                        height="500"
                    >
                        <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                        <vxe-table-column field="actor_pname" title="操作者姓名" width="100" align="center"> </vxe-table-column>
                        <vxe-table-column field="actor_oname" title="操作者组织名称" width="200" align="center"> </vxe-table-column>
                        <vxe-table-column field="operdesc" title="操作描述" width="200"> </vxe-table-column>
                        <vxe-table-column field="opernote" title="操作说明"> </vxe-table-column>
                        <vxe-table-column field="operdate" title="操作时间" width="150"></vxe-table-column>
                    </vxe-table>
                </a-tab-pane>
            </a-tabs>
        </div>
    </div>
</template>
<script>
import BpmnViewer from "bpmn-js/lib/Viewer";
import util from "../../utils/util";
export default {
    name: "ActiveHistoryProcess",
    props: ["histProcProps"],
    data() {
        return {
            util,
            tableData: [],
            hisProData: [],
            bpmnXml: "",
            bpmnViewer: null,
            userList: []
        };
    },
    watch: {
        histProcProps: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                if (newVal.visible) {
                    let _this = this;
                    if (_this.billid !== null && _this.billid !== "") {
                        _this.queryOperateLog();
                        _this.init();
                    }
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        queryOperateLog() {
            this.$FG_http
                .post(
                    "./api/activiti/queryOperateLog",
                    {
                        billid: this.histProcProps.billid
                    },
                    {
                        showError: true,
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        this.tableData = data.data;
                    }
                });
        },
        init() {
            let canvas = this.$refs.canvas;
            this.bpmnViewer && this.bpmnViewer.destroy();
            this.bpmnViewer = new BpmnViewer({
                container: canvas
            });

            this.$FG_http
                .post(
                    "./api/activiti/readTrackingXML",
                    {
                        processKey: this.histProcProps.processKey,
                        instanceId: this.histProcProps.instanceId === null ? "" : this.histProcProps.instanceId
                    },
                    {
                        showError: true,
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    if (success) {
                        this.hisProData = data.data.hisact;
                        this.bpmnXml = this.changeHtmlText(data.data.xml);
                        this.importXML();
                    }
                });
        },
        async importXML() {
            this.bpmnViewer.importXML(this.bpmnXml, (err) => {
                if (err) {
                    // console.error(err);
                }
                const bpmnCanvas = this.bpmnViewer.get("canvas");
                bpmnCanvas.zoom("fit-viewport");
                this.highlight(bpmnCanvas);
            });
        },
        highlight(bpmnCanvas) {
            this.hisProData.forEach((element) => {
                if (element.czlx === "审核批准") {
                    bpmnCanvas.addMarker(element.act_id_, "highlighted");
                }
                if (element.czlx === "正在审批") {
                    bpmnCanvas.addMarker(element.act_id_, "highlighting");
                }
                if (element.czlx === "暂停") {
                    bpmnCanvas.addMarker(element.act_id_, "suspending");
                }
            });
        },
        changeHtmlText(xmlStr) {
            let me = this;
            let xmlObj = new DOMParser().parseFromString(xmlStr, "text/xml");
            let userTasks = xmlObj.getElementsByTagName("userTask");
            userTasks.forEach((element) => {
                for (let i = 0; i < me.hisProData.length; i++) {
                    if (me.hisProData[i].act_id_ === element.id) {
                        element.setAttribute("name", me.hisProData[i].act_name_ + "\n" + "(" + me.hisProData[i].personnel_name + ")");
                        // let flag = 0;
                        // for (let j = 0; j < me.tableData.length; j++) {
                        //     if (me.hisProData[i].assignee_ === me.tableData[j].actor_uname) {
                        //         element.setAttribute("name", me.tableData[j].actor_pname);
                        //         flag = 1;
                        //         break;
                        //     }
                        // }
                        // if (flag === 1) {
                        //     break;
                        // }
                    }
                }
            });
            return new XMLSerializer().serializeToString(xmlObj);
        }
    },
    mounted() {}
};
</script>
<style>
.canvas {
    width: 100%;
    height: 500px;
}
.suspending:not(.djs-connection) .djs-visual > :nth-child(1) {
    stroke: rgb(222 182 11) !important;
    fill: rgb(234 210 5) !important; /* color elements as yellow */
}
.highlighted:not(.djs-connection) .djs-visual > :nth-child(1) {
    stroke: rgb(103 200 210) !important;
    fill: rgb(12 220 230) !important; /* color elements as blue */
}
.highlighting:not(.djs-connection) .djs-visual > :nth-child(1) {
    stroke: rgb(81 113 65) !important;
    fill: rgb(49 228 37) !important; /* color elements as green */
}
</style>
